import { BRAND_PREFERENCES_UPDATE, BRAND_SETTINGS_UPDATE, BRAND_SECRETS_UPDATE } from "constants/action-types";
import { ISaveSecrets } from "containers/admin/settings/pricing/interfaces";

export const updatePreferences = (preferences) => ({
    payload: preferences,
    type: BRAND_PREFERENCES_UPDATE,
});

export const updateSettings = (settings) => ({
    payload: settings,
    type: BRAND_SETTINGS_UPDATE,
});

export const updateSecrets = (brandId, secrets: ISaveSecrets) => ({
    payload: { brandId, secrets },
    type: BRAND_SECRETS_UPDATE,
});
